import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';

import { ElearningType } from '@/modules/types/elearning';

export const elearningAdapter = createEntityAdapter();

const initialState: ElearningType = elearningAdapter.getInitialState({
  isSaved: false,
  isLoaded: false,
  isLoading: false,
  data: null,
});

const elearningSlice = createSlice({
  name: 'elearning',
  initialState,
  reducers: {
    fetch: (state) => {
      state.isLoaded = false;
      state.isLoading = true;
      state.data = null;
    },
    fetchSuccess: (state, action) => {
      state.isLoaded = true;
      state.isLoading = false;
      // eslint-disable-next-line prefer-destructuring
      state.data = action.payload.data; // There will be only one elearning module data
    },
    fetchFailure: (state, action) => {
      state.isLoaded = true;
      state.isLoading = false;
      state.error = action.payload.error;
    },
    saveElearning: (state, action) => {
      state.isLoading = true;
    },
    saveElearningSuccess: (state, action) => {
      state.isSaved = true;
    },
    saveElearningFailure: (state, action) => {
      state.isSaved = false;
    },
  },
});

export const { name, actions, reducer } = elearningSlice;
